export default function NotificationSecondaryIcon() {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7364 17.4629C10.2545 17.3588 7.31794 17.3588 6.83601 17.4629C6.42403 17.5592 5.97852 17.7832 5.97852 18.2744C6.00247 18.743 6.27361 19.1567 6.64918 19.419L6.64823 19.42C7.13398 19.8031 7.70405 20.0467 8.30095 20.1342C8.61903 20.1784 8.94287 20.1764 9.27246 20.1342C9.86839 20.0467 10.4385 19.8031 10.9242 19.42L10.9233 19.419C11.2988 19.1567 11.57 18.743 11.5939 18.2744C11.5939 17.7832 11.1484 17.5592 10.7364 17.4629Z"
        fill="#7B9E7E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2895 10.0658C15.5853 9.23368 15.2653 8.51257 15.2653 7.28747V6.87092C15.2653 5.27445 14.9022 4.24584 14.1127 3.21722C12.896 1.61977 10.8475 0.656982 8.84224 0.656982H8.75697C6.79383 0.656982 4.8096 1.57556 3.57174 3.10817C2.73915 4.15742 2.33388 5.23024 2.33388 6.87092V7.28747C2.33388 8.51257 2.03495 9.23368 1.30967 10.0658C0.77601 10.6789 0.605469 11.4668 0.605469 12.3195C0.605469 13.1733 0.882359 13.9818 1.43806 14.6391C2.16334 15.427 3.18754 15.93 4.23379 16.0174C5.74854 16.1923 7.26329 16.2581 8.80008 16.2581C10.3359 16.2581 11.8507 16.1481 13.3664 16.0174C14.4117 15.93 15.4359 15.427 16.1611 14.6391C16.7159 13.9818 16.9937 13.1733 16.9937 12.3195C16.9937 11.4668 16.8232 10.6789 16.2895 10.0658Z"
        fill="#7B9E7E"
      />
    </svg>
  );
}
